import { IApplicationState } from '../../types/redux';

export function getAerialViewLink(state: IApplicationState): string | null {
  const { newbuilding } = state;

  return (newbuilding.panorama && newbuilding.panorama.url) || null;
}
